import { fetchIsEmailRegistered } from '../repositories/users/v1/is-email-registered';
export function isEmailRegistered(httpApi, parameters) {
  return fetchIsEmailRegistered({
    httpApi: httpApi,
    parameters: parameters
  });
}